import CircularProgressWithLabel from "./CircularProgress";
import LinearProgressWithLabel from "./LinearProgress";

const CustomProgress = {
  Circular: CircularProgressWithLabel,
  linear: LinearProgressWithLabel,
};

export default CustomProgress;
